import React from 'react';
import { Link } from 'react-router-dom';

export const VendedorLoadingState = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center" data-testid="vendedor-loading-state">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" data-testid="vendedor-loading-spinner"></div>
    </div>
  );
};

export const VendedorErrorState = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4" data-testid="vendedor-error-state">
      <div className="bg-white rounded-2xl shadow-xl p-8 text-center max-w-md">
        <div className="text-6xl mb-4">😕</div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-testid="vendedor-error-title">Vendedor não encontrado</h2>
        <p className="text-gray-600 mb-6" data-testid="vendedor-error-description">O link pode estar incorreto ou o vendedor não está mais disponível.</p>
        <Link to="/" className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition" data-testid="vendedor-error-home-link">
          Ir para o Site Principal
        </Link>
      </div>
    </div>
  );
};

export const VendedorSubmittedState = ({ vendedorName, onBack, onGoHome }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4" data-testid="vendedor-submitted-state">
      <div className="bg-white rounded-2xl shadow-xl p-8 text-center max-w-md">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">✅</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2" data-testid="vendedor-submitted-title">Mensagem Enviada!</h2>
        <p className="text-gray-600 mb-6" data-testid="vendedor-submitted-message">{vendedorName} recebeu seu contato e entrará em contato em breve!</p>
        <div className="flex flex-col gap-3">
          <button onClick={onBack} className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition" data-testid="vendedor-submitted-back-button">
            Voltar
          </button>
          <button onClick={onGoHome} className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition" data-testid="vendedor-submitted-home-button">
            Ir para o Site Principal
          </button>
        </div>
      </div>
    </div>
  );
};
